export default __webpack_public_path__ + "static/media/turkey.7341e8d0.svg";